module.exports = __webpack_public_path__ + "static/media/forest_tree_layer.9b8c58c0.png";